import React from "react";
import OperatorRequestDetails from "./OperatorRequestDetails";

const ImportationDetails = () => <OperatorRequestDetails />;

export default ImportationDetails;
